import ManagementReportForm from './ManagementReportForm';
export default ManagementReportForm;